export const AdReplyEvent = {
  ContactButtonClick: 'subito:AdView:BtnAuthorReply',
  Close: 'subito:AdReply:Close',
  Cancel: 'subito:AdReply:Cancel',
  Show: 'subito:AdReply:Show',
};
